var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchantSignUp1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .2;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #e39435;\n      }\n\n      .cls-5 {\n        fill: #37474f;\n      }\n\n      .cls-6 {\n        fill: #ebe5e1;\n      }\n\n      .cls-7 {\n        fill: #6e433d;\n      }\n\n      .cls-8, .cls-9, .cls-10 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-8, .cls-11 {\n        fill: #f24e4a;\n      }\n\n      .cls-12 {\n        fill: none;\n        stroke: #be232d;\n        stroke-miterlimit: 10;\n        stroke-width: .5px;\n      }\n\n      .cls-9, .cls-13 {\n        fill: #f8b053;\n      }\n\n      .cls-9, .cls-14, .cls-3, .cls-10 {\n        opacity: .4;\n      }\n\n      .cls-15 {\n        fill: #4a312d;\n      }\n\n      .cls-16, .cls-17 {\n        fill: #845d5d;\n      }\n\n      .cls-16, .cls-18 {\n        font-family: Viga-Regular, 'Viga Regular';\n        font-size: 44.89px;\n      }\n\n      .cls-19 {\n        fill: #e2dac8;\n      }\n\n      .cls-20 {\n        isolation: isolate;\n      }\n\n      .cls-21 {\n        fill: #81abc0;\n      }\n\n      .cls-22 {\n        fill: #ff8d7e;\n      }\n\n      .cls-10 {\n        fill: #355c24;\n      }\n\n      .cls-23 {\n        fill: #be232d;\n      }\n\n      .cls-24 {\n        fill: #ffcd7d;\n      }\n\n      .cls-18 {\n        fill: #583c37;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 289.27,
    y: 364.59,
    width: 107.25,
    height: 8.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 100.05,
    y: 204.81,
    width: 296.47,
    height: 214.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 100.05,
    y: 372.59,
    width: 296.47,
    height: 46.58
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 100.05,
    y: 365.37,
    width: 296.47,
    height: 8.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 100.05,
    y: 368.75,
    width: 296.47,
    height: 1.66
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M396.52,209.63H100.05v36.23c7.87-2.21,13.72-9.25,14.14-17.74.5,10.28,8.98,18.47,19.39,18.47s18.89-8.19,19.4-18.47c.51,10.28,8.98,18.47,19.4,18.47s18.88-8.18,19.4-18.45c.52,10.27,8.99,18.45,19.4,18.45s18.89-8.19,19.4-18.47c.51,10.28,8.98,18.47,19.39,18.47s18.88-8.18,19.4-18.46c.51,10.28,8.99,18.46,19.39,18.46s18.88-8.17,19.4-18.44c.52,10.27,8.99,18.44,19.39,18.44s18.89-8.19,19.39-18.47c.51,10.28,8.99,18.47,19.4,18.47s18.89-8.18,19.4-18.46c.36,7.22,4.66,13.4,10.79,16.44v-34.94Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "75.06 203.83 109.56 141.86 385.5 141.86 424.29 203.83 75.06 203.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "113.95 203.83 133.3 145.96 107.22 145.96 75.06 203.83 113.95 203.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "152.65 203.83 165.29 145.96 196.34 145.96 191.44 203.83 152.65 203.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "230.24 203.83 228.19 145.96 259.68 145.96 269.02 203.83 230.24 203.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "307.82 203.83 288.47 145.96 323.19 145.96 346.7 203.83 307.82 203.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "385.5 203.83 361.85 145.96 388.13 145.96 424.29 203.83 385.5 203.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M75.06,203.83v17.52c0,10.74,8.7,19.45,19.45,19.45s19.44-8.7,19.44-19.45v-17.52h-38.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.86,203.83v17.52c0,10.74,8.7,19.45,19.44,19.45s19.45-8.7,19.45-19.45v-17.52h-38.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M152.65,203.83v17.52c0,10.74,8.71,19.45,19.45,19.45s19.44-8.7,19.44-19.45v-17.52h-38.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M191.44,203.83v17.52c0,10.74,8.71,19.45,19.45,19.45s19.44-8.7,19.44-19.45v-17.52h-38.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M230.24,203.83v17.52c0,10.74,8.7,19.45,19.44,19.45s19.44-8.7,19.44-19.45v-17.52h-38.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M269.02,203.83v17.52c0,10.74,8.71,19.45,19.44,19.45s19.45-8.7,19.45-19.45v-17.52h-38.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M307.82,203.83v17.52c0,10.74,8.7,19.45,19.45,19.45s19.44-8.7,19.44-19.45v-17.52h-38.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M385.4,203.83v17.52c0,10.74,8.71,19.45,19.45,19.45s19.45-8.7,19.45-19.45v-17.52h-38.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M346.61,203.83v17.52c0,10.74,8.7,19.45,19.45,19.45s19.45-8.7,19.45-19.45v-17.52h-38.89Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 102.18,
    y: 139.99,
    width: 292.61,
    height: 5.98
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.06,
    y: 201.97,
    width: 349.23,
    height: 2.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 111.24,
    y: 252.37,
    width: 173.05,
    height: 104.13
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "156.08 252.37 284.38 339.3 284.38 301.48 213.32 252.37 156.08 252.37"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M111.53,252.47v82.33s11.71-2.07,25.22-23.29c13.51-21.21,18.31-59.05,18.31-59.05h-43.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M141.86,356.4c-1.54-3.42-3.23-6.68-5.1-9.61-13.52-21.22-25.22-23.28-25.22-23.28v32.89h30.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M285.32,252.47v82.33s-11.71-2.07-25.22-23.29c-13.51-21.21-18.31-59.05-18.31-59.05h43.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M254.99,356.4c1.55-3.42,3.24-6.68,5.1-9.61,13.51-21.22,25.22-23.28,25.22-23.28v32.89h-30.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M288.42,248.7H107.1v111.77h181.02v-.35h.3v-111.42ZM111.39,252.46h172.75v104.27H111.39v-104.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "111.5 356.5 175.03 356.5 111.5 310.99 111.5 356.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "111.5 253.96 111.5 291.23 205.81 356.5 255.93 356.5 111.5 253.96"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 300.56,
    y: 268.77,
    width: 84.66,
    height: 150.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 304.56,
    y: 272.61,
    width: 76.67,
    height: 146.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 306.43,
    y: 275.06,
    width: 72.94,
    height: 141.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 310.69,
    y: 277.72,
    width: 64.95,
    height: 80.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M316.32,367.05c0,1.56-1.26,2.82-2.82,2.82s-2.81-1.26-2.81-2.82,1.26-2.82,2.81-2.82,2.82,1.26,2.82,2.82Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "310.69 277.7 375.64 358.64 310.69 358.64 310.69 277.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "326.16 277.7 375.64 336.54 375.64 310.95 348.24 277.7 326.16 277.7"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 83.24,
    y: 417.26,
    width: 332.88,
    height: 12.37
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M432.49,473.66s4.97,11.51,3.47,14c-1.5,2.49-11.19,6.23-14.75,6.86-3.57.61-6.12,1.01-6.43-.27-.95-3.75,10.46-8.16,6.38-6.36-3.05,1.34,8.15-3.1,7.46-8.48-.55-4.38.13-4.81.13-4.81l3.75-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M329.77,466.1s1.36,12.46-.82,14.4c-2.17,1.94-12.54,2.65-16.12,2.2-3.58-.48-6.14-.84-6.07-2.17.2-3.86,12.41-4.71,7.97-4.19-3.32.38,8.7-.55,9.63-5.89.77-4.34,1.55-4.56,1.55-4.56l3.86.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M424.36,373.48c4.27-23.11,2.59-58.86,3.84-84.43.19-4.03.36-7.8.49-11.46h.01c-.17-3.39,9.95-31.78-4.35-57.09h-78.54c-3.05,12.31-10.18,37.29-11.35,47.47-.32,2.85-.68,5.88-1.07,9.12-2.45,20.36-8.59,69.52-8.45,92.26-.15,1.51-.28,3.18-.39,5.06-.76,13.63-5.57,98.27-5.57,98.27l11.99.68s11.71-35.46,15.17-64.17c1.86-15.44,2.63-28.88,2.19-34.86,19.34-31.02,29.56-101.9,30.81-101.85.49,3.94,9.5,66.35,16.3,90.11,2.27,12.28,6.21,15.87,7.43,21.47,2.9,13.34,20.95,96.18,20.95,96.18l11.73-2.56s1.78-37.32-2.58-65.9c-2.14-14.08-6.67-32.5-8.63-38.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M417.68,262.33c-.35-12.35-.12-30.5-.12-30.5l-72.28,2.03-17.27,90.62,37.29,5.98,14.05-55.64,9.88,59.48,22.74,3.65s6.07-63.27,5.72-75.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M473.27,106.44c-8.12-7.3-20.92-3.94-30.82-5.4-7.62-1.13-12.49-5.23-13.18-12.94-.42-4.65.51-9.4-1.5-13.77-3.36-7.34-15.02-6.01-21.16-8.74-5.24-2.34-6.77-8-7.6-13.17-.76-4.67-1.89-9.13-4.41-13.19-4.8-7.74-14.52-10.14-23.03-8.89-7.73,1.13-14.89,5.47-20.69,10.83-1.85.99-3.21,2.43-3.94,4.04-.15.17-.31.34-.46.52-.2.24-.13.49.05.64-.78,2.97.55,6.18,4.83,7.76.16.06.32.06.47.04,3.96,4.48,9.37,7.77,13.36,12.57,4.38,5.29,2.87,11.93,5.62,17.8,2.23,4.75,8.03,6.46,10.57,10.99,3.08,5.5-1.2,13-4.01,17.65-2.93,4.85-6.36,9.39-9.36,14.2-5.49,8.79-8.2,18.06-7.56,28.44,1.12,18.07,13.02,34.53,32.17,34.66,13.43.09,23.69,14.46,50.78,3.99,35.84-13.86,1.22-31.59,23.38-41.77,9.73-4.47,14.03-12.69,15.92-22.71,1.38-7.29-3.14-17.88-9.43-23.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M319.13,124.76c-4.34,9.8,4.44,29.24,5.29,39.73.67,8.27.92,13.9.92,13.9,0,0-28.34,30.13-36.91,32.94-8.57,2.82-9.46,3.07-14.26,4.85-4.8,1.76-10.62,3.48-10.14,6.44.48,2.96,7.58,7.25,14.34,5.34,6.76-1.91,10.01-8.58,16.94-10.32,13.5-3.4,51.07-22.24,53.66-29.81,2.58-7.57-4.58-62.57-8.65-67.04-4.07-4.46-19-.94-21.19,3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.43,102.21c-8.15,3.45-20.37,16.41-21.66,26.27-1.76,13.51-.25,33.46,1.31,38.41,1.57,4.95,40.86-7.92,40.86-7.92,0,0-5.13-17.96-7.73-28.54-2.6-10.57-4.76-15.77-8.33-21.43-3.57-5.67-1.16-8.18-4.44-6.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M270.89,210.31s7.38,1.21,11.11,2.01c3.72.79,7.27,1.2,7.27,1.2l-6.94,3.71-3.08-.36s-1.57-1.16-3.69-2.24c-2.13-1.08-3.79-1.87-4.39-2.65-.58-.79-.27-1.66-.27-1.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M325.07,118.72c2.51-8.99,2.82-13.36,10.36-16.51,12.16-5.09,29.32-7.45,43.9-5.87,6.93.75,20.88,2.46,27.7,6.94,6.83,4.49,9.28,28.75,5.88,47.11-3.4,18.36-4.44,27.65-2.81,34.74,1.63,7.1,4.18,14.48,9.48,25.29,5.29,10.82,10.92,10.74,5.03,16.94-5.89,6.2-39.14,17.45-58.12,15.45-12.96-1.36-23.11-9.66-23.11-9.66,0,0,4.97-20.68,2.05-35.37-2.92-14.69-12.82-45.07-16.56-51.86-3.76-6.79-5.66-20.55-3.8-27.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M315.35,317.99s23.85-63.46,25.12-83.34c1.26-19.88-10.45-67.43-11.75-77.45-1.96-15.04,5.09-54.99,5.09-54.99l6.67-2.37-1.11,35.61,34.59-2.08,3.76-37.04h4.49s1.84,41.4,5.31,67.42c3.47,26.02,14.15,42.63,17.91,53.95,4.73,14.26,5.95,38.32,4.6,59.95-1.35,21.63-4.15,49.87-4.15,49.87l-90.53-9.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "389.34 182.64 406.53 175.54 409.35 182.93 391.02 192.64 389.34 182.64"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M329.51,142.21c-.82,0-.55-3.54-.55-3.54l30.41,1.77-4.47,76.78-14.07,1.18-11.31-76.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M405.96,106.51c-.3.04-.59.11-.88.2l.88-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M394.09,192.64h0c-9.66,8.33-24.78,20.87-30.43,22.72-1.71.56-3.1,1.02-4.3,1.41-.69-.13-1.4-.26-2.14-.42-3.73-.79-11.1-2.01-11.1-2.01,0,0-.32.88.27,1.66.6.79,2.26,1.58,4.39,2.65.41.2.79.42,1.15.62-.75.27-1.56.56-2.53.92-4.8,1.76-10.62,3.48-10.13,6.44.48,2.96,7.58,7.25,14.34,5.34,6.77-1.91,10.01-8.59,16.94-10.32,6.74-1.69,19.46-7.23,30.84-13.29l-7.29-15.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 217.96,
    y: 151.14,
    width: 136.68,
    height: 65.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 222.39,
    y: 155.21,
    width: 127.82,
    height: 57.27
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(230.16 199.81) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OPEN")), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(231.19 199.62) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OPEN"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M391.71,124.76c-4.34,9.8,4.44,29.24,5.29,39.73.67,8.27,2.98,16.61,2.98,16.61,0,0-30.39,27.42-38.96,30.23-8.57,2.82-9.46,3.07-14.27,4.85-4.8,1.76-10.61,3.48-10.13,6.44.48,2.96,7.58,7.25,14.34,5.34,6.76-1.91,10.01-8.58,16.94-10.32,13.5-3.4,51.08-22.24,53.66-29.81,2.58-7.57-4.58-62.57-8.65-67.04-4.07-4.46-19-.94-21.19,3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401.83,102.84c-8.14,3.45-11.84,14.95-13.13,24.81-1.77,13.51,2.77,33.42,4.34,38.37,1.57,4.95,35.48-7.04,35.48-7.04,0,0-5.12-17.96-7.73-28.54-2.6-10.57-4.76-15.77-8.33-21.43-3.58-5.67-7.35-7.55-10.63-6.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M343.47,210.31s7.37,1.21,11.1,2.01c3.73.79,7.27,1.2,7.27,1.2l-6.95,3.71-3.08-.36s-1.57-1.16-3.69-2.24c-2.13-1.08-3.79-1.87-4.39-2.65-.59-.79-.27-1.66-.27-1.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M348.46,104.04c2.12-6.29,2.41-12,.8-17.38-1.61-5.38-4-10.69-4-10.69l18.85-14.48s3.6,18.15,4.51,26.94c.73,7.16,1.83,9.85,1.31,14.65-.59,5.44-7.06,9.17-15.64,7.09-8.72-2.12-6.51-4.12-5.83-6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.06,90.37s7.08-3.21,9.31-6.89c2.23-3.67,3.53,3.16.84,7.7-2.69,4.54-10.7,9.11-10.7,9.11,0,0,1.07-4.16.86-6-.2-1.84-.32-3.93-.32-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M334.4,54.53c-2.12,3.56-2.05,7.67-1.39,19.24.61,10.58,8.27,15.53,13.31,16.41,6.81,1.19,11.32-.68,15.13-8.1,3.8-7.42,5.2-17.55-1.01-29.12-2.89-5.4-10.63-6.31-14.62-5.53-3.98.78-9.78,4.32-11.43,7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M359.78,43.36c-4-1.49-8.31-2.48-12.3-1.58-3.67.83-5.73,8.78-6.52,10.14-.16.28-.02.71.31.77,1.2.23,2.31.3,3.54.35,2.89.11,5.57,1.81,7.98,3.28,4.07,2.48,7.83,4.82,10.52,8.89.32.49.91.45,1.24,0,5.88-7.62,5.52-18.03-4.78-21.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M364.17,60.81c0,2.11-.31,4.14-.87,6.07h6.21c2.2-3.38,3.49-7.41,3.49-11.76,0-11.86-9.52-21.48-21.26-21.48-6.1,0-11.59,2.61-15.47,6.77,2.09-.69,4.32-1.08,6.64-1.08,11.74,0,21.26,9.61,21.26,21.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M361.42,50.26c-1.81-4.58-3.75-8.82-10.04-11.48-8.32-3.51-15.63-1.15-21.74,2.31-2.5,1.42-4.57,3.5-5.88,6.05-1.57,3.08-.22,6.22-2.56,8.77-.52.27-1.04.53-1.51.8-1.97,1.14-3.65,3.09-3.69,5.48-.1,6,6.01,7.82,11.04,8.11,7.31.42,9.54-7.23,14.67-10.79,2.85-1.98,6.8-1.4,9.97-2.66,2.31-.92,3.49-2.95,4.47-5.1.96-2.11,6.18.75,5.29-1.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M372.82,70.86c-1.47,3.24-4.97,4.83-7.8,3.55-2.83-1.29-3.93-4.96-2.45-8.21,1.48-3.24,4.96-4.83,7.8-3.54,2.83,1.29,3.93,4.96,2.45,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M366.76,70.78c1.57-.93,2.3-2.61,1.62-3.74"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M351.84,64.11c.76-.61,1.99-.6,2.92-.59,1.1,0,2.36.09,3.34.54.09.04.05.18-.06.18-2.06.04-3.89-.37-5.93.29-.26.09-.5-.25-.28-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M353.4,67.19c.13.69.85,1.13,1.62.98.77-.14,1.28-.81,1.15-1.49-.13-.69-.84-1.13-1.61-.99-.77.14-1.29.81-1.16,1.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M341.29,66c.2.05.25.32.02.38-.85.23-1.8.21-2.67.33-.58.08-1.14.21-1.7.4-.45.14-.69.51-1.1.63-.13.04-.31-.02-.34-.15-.46-1.58,4.85-1.81,5.79-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M338.77,69.42c.13.69.85,1.13,1.63.99.75-.14,1.27-.81,1.15-1.5-.13-.69-.85-1.13-1.61-.99-.77.14-1.29.82-1.16,1.5Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M359.55,71.89c.03.23.27.37.53.33.26-.04.43-.27.38-.49-.04-.23-.27-.37-.53-.33-.25.05-.43.27-.38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M357,70.95c.03.23.28.38.53.33.26-.04.43-.27.38-.49-.04-.23-.27-.37-.53-.33-.25.05-.42.27-.38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M357.38,73c.04.23.27.37.53.33.26-.04.43-.27.38-.5-.05-.22-.29-.37-.53-.33-.26.04-.43.27-.38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M354.96,72.74c.04.23.27.37.53.33.26-.04.42-.27.38-.49-.04-.23-.29-.37-.53-.33-.25.04-.42.27-.38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M356.23,75.34c.04.23.28.38.54.32.24-.04.42-.27.38-.49-.04-.23-.28-.37-.54-.32-.24.05-.43.27-.38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M359.16,74.09c.03.23.28.38.53.33.26-.04.42-.27.38-.49-.04-.23-.27-.37-.53-.33-.25.05-.43.27-.38.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M340.31,74.74c.05.23.29.38.53.33.26-.05.43-.27.38-.5-.04-.23-.27-.37-.53-.33-.25.05-.42.27-.38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337.77,73.8c.05.23.29.37.53.33.25-.05.42-.27.39-.5-.04-.23-.29-.37-.54-.32-.26.04-.42.27-.38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M338.15,75.86c.04.23.28.38.53.33.26-.05.42-.27.38-.49-.03-.23-.27-.37-.53-.33-.25.05-.43.27-.38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M335.73,75.59c.04.23.28.38.53.33.26-.04.43-.27.38-.49-.03-.23-.27-.37-.53-.33-.25.05-.43.27-.38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337,78.2c.05.22.28.37.54.33.24-.05.41-.27.38-.5-.04-.23-.28-.37-.54-.32-.24.04-.42.27-.38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.93,76.95c.05.22.28.37.53.32.25-.05.42-.27.38-.5-.03-.23-.27-.37-.53-.33-.25.05-.43.27-.38.5Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M348.5,78.41c-2.25.34-4.35.36-6.1.13,1.09,3.39,3.87,4.75,6.87,4.3,4.75-.72,5.44-4.26,5.54-6.32-1.67.84-3.86,1.52-6.31,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.5,78.41c-2.25.34-4.36.36-6.11.13.09.26.17.52.3.78,1.8.18,4.26.52,6.27.21,2.26-.34,3.98-1.3,5.76-2.12.09-.32.13-.64.14-.92-1.68.85-3.89,1.55-6.36,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M345.12,82.14c1.21.71,2.64.93,4.15.71,1.83-.28,3.05-.97,3.87-1.84-1.03-.74-2.6-1.1-4.27-.84-1.61.24-2.97,1.01-3.75,1.98Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M344.8,74.06c-.43-1.8,2.12-2.35,1.8-4.18-.02-.08.11-.1.13-.02.29,1.03-.06,1.59-.8,2.31-.74.72-1.07,1.51-.58,2.51.45.89,1.58,1.56,2.57,1.32.28-.07.37.36.08.38-1.49.16-2.85-.88-3.21-2.33Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantSignUp1);
export default __webpack_public_path__ + "static/media/MerchantSignUp1.d96918adb1d9381ec118d261327ebbee.svg";
export { ForwardRef as ReactComponent };